<template>
  <div class="smiles-container" v-show="showAllSvg">
    <div class="all-center px-5">
      <div>
        <div
          class="reactants-wrapper"
          style="float: left; height: 220px;"
          @click="
            getReactionDetail(
              'reactant',
              item.smilesId,
              item.svgStr,
              item.smiles
            )
          "
          v-for="(item, index) in reactionArr.reactants"
        >
          <div class="all-center">
            <div
              v-html="item.svgStr"
              :ref="item.id"
              class="indigo-svg-wrapper d-flex justify-center"
              style="max-width: 170px; overflow: hidden;"
            ></div>

            <div
              v-if="reactionArr.reactants.length - 1 !== index"
              class="all-center"
              style="padding: 8px; height: 120px;"
            >
              <v-icon color="#333">mdi-plus</v-icon>
            </div>
          </div>
        </div>
        <div
          class="d-inline-block mr-8 ml-4"
          style="
            float: left;
            position: relative;
            min-width: 50px;
            height: 220px;
          "
        >
          <div
            class="arrow pr-8 pl-4"
            style="
              position: absolute;
              top: 50%;
              left: 0;
              transform: translateY(-50%);
              height: 2px;
              background: #333;
              width: 100%;
              min-width: 50px;
            "
          ></div>
          <div
            class="catalyst-wrapper d-flex justify-center align-start"
            style="float: left; height: 220px;"
            v-for="(item, index) in reactionArr.catalyst"
            @click="
              getReactionDetail(
                'catalyst',
                item.smilesId,
                item.svgStr,
                item.smiles
              )
            "
          >
            <div
              v-html="item.svgStr"
              :ref="item.id"
              class="indigo-svg-wrapper catalyst-svg"
              style="max-width: 170px; height: 120px;"
            ></div>
          </div>
        </div>

        <div
          class="generating-wrapper"
          style="float: left; height: 220px;"
          @click="
            getReactionDetail(
              'generating',
              item.smilesId,
              item.svgStr,
              item.smiles
            )
          "
          v-for="(item, index) in reactionArr.generating"
        >
          <div class="all-center">
            <div
              v-html="item.svgStr"
              :ref="item.id"
              class="indigo-svg-wrapper d-flex justify-center"
            ></div>
            <div
              v-if="reactionArr.generating.length - 1 !== index"
              class="px-2"
            >
              <v-icon color="#333">mdi-plus</v-icon>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showFormula"
      style="
        width: 100%;
        font-size: 14px;
        height: 50px;
        border-top: 1px solid #f5f5f5;
      "
      class="d-flex justify-center"
    >
      <div class="all-center px-2" style="float: left;">
        <div v-for="(str, index) in formulaArr[0]" class="all-center">
          {{ str }}
          <div v-if="index !== formulaArr[0].length - 1" class="px-1">
            +
          </div>
        </div>
      </div>
      <div
        style="float: left; position: relative; min-width: 40px;"
        class="d-flex justify-start align-start"
      >
        <div class="px-2" v-for="str in formulaArr[1]">{{ str }}</div>

        <div
          class="arrow"
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            width: 100%;
            transform: translate(-50%, -50%);
            height: 2px;
            background: black;
            margin-right: 20px;
          "
        ></div>
      </div>

      <div class="all-center px-6" style="float: left;">
        <div class="all-center" v-for="(str, index) in formulaArr[2]">
          {{ str }}
          <div class="px-1" v-if="index !== formulaArr[2].length - 1">
            <div>+</div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="description all-center"
      v-if="showFormula && (yield1 || formulaArr[1].length)"
      style="border-top: 1px solid #f5f5f5;"
    >
      <div
        class="catalyst text-center flex-grow-1"
        v-show="showFormula && formulaArr[1].length"
        style=""
      >
        <span>{{ $i18n.t("catalyst") }} : </span>
        <span v-for="item in formulaArr[1]" class="px-2">{{ item }}</span>
      </div>
      <div
        style="text-align: center; height: 100%; flex-grow: 1;"
        v-if="yield1"
      >
        {{ $i18n.t("yield") }}: {{ yield1 }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "SmilesItem",
  props: {
    str: Object,
    yield1: Number,
    index: Number,
  },
  data() {
    return {
      indigosmiles: "",
      formulaArr: [],
      showFormula: false,
      ConcatSmiles: "",
      reactionArr: {
        reactants: [],
        catalyst: [],
        generating: [],
      },
      showAllSvg: false,
    };
  },

  mounted() {
    let reactants = this.uniqueArr(this.str.reactants) || [];
    let catalysts = this.uniqueArr(this.str.catalysts) || [];
    let products = this.uniqueArr(this.str.products) || [];
    this.oldArr = reactants.length + catalysts.length + products.length;

    let str1 = this.arrToStr(reactants);
    let str2 = this.arrToStr(catalysts);
    let str3 = this.arrToStr(products);
    this.ConcatSmiles = str1 + ">" + str2 + ">" + str3;

    this.changeSmilesToFormula(this.ConcatSmiles);

    this.changeSvgStyle(reactants, this.reactionArr.reactants, 1);
    this.changeSvgStyle(catalysts, this.reactionArr.catalyst, 2);
    this.changeSvgStyle(products, this.reactionArr.generating, 3);
  },

  methods: {
    ...mapActions(["smilesToSvg", "reactionToFormula"]),
    arrToStr(arr) {
      let str = "";
      for (let i = 0; i < arr.length; i++) {
        if (i === arr.length - 1) {
          str = str + arr[i].smiles;
        } else {
          str = str + arr[i].smiles + ".";
        }
      }
      return str;
    },
    changeSmileToSvg(smiles) {
      return this.smilesToSvg({ smiles });
    },
    changeSmilesToFormula(smiles) {
      this.reactionToFormula({ smiles }).then((res) => {
        console.log(res);
        this.formulaArr.push(Array.from(new Set(res.data[0])));
        this.formulaArr.push(Array.from(new Set(res.data[1])));
        this.formulaArr.push(Array.from(new Set(res.data[2])));
        this.showFormula = true;
      });
    },
    changeSvgStyle(old, newV, index) {
      // 原始数组  新生成的svg数组
      if (old.length === 0) return;
      for (let i = 0; i < old.length; i++) {
        this.changeSmileToSvg(old[i].smiles).then((res) => {
          let a1 = "a" + this.createRandomId();
          let a2 = "a" + this.createRandomId();
          let a3 = "a" + this.createRandomId();
          let a4 = "a" + this.createRandomId();
          let a5 = "a" + this.createRandomId();
          let a6 = "a" + this.createRandomId();
          let a7 = "a" + this.createRandomId();
          let a8 = "a" + this.createRandomId();
          let a9 = "a" + this.createRandomId();
          let a10 = "a" + this.createRandomId();
          let svgStr = res.data
            .replace(new RegExp("glyph0", "gm"), a1)
            .replace(new RegExp("glyph1", "gm"), a2)
            .replace(new RegExp("glyph2", "gm"), a3)
            .replace(new RegExp("glyph3", "gm"), a4)
            .replace(new RegExp("glyph4", "gm"), a5)
            .replace(new RegExp("glyph5", "gm"), a6)
            .replace(new RegExp("glyph6", "gm"), a7)
            .replace(new RegExp("glyph7", "gm"), a8)
            .replace(new RegExp("glyph8", "gm"), a9)
            .replace(new RegExp("glyph9", "gm"), a10);
          newV.push({
            svgStr: svgStr,
            smilesId: old[i].smilesId,
            id: "reactants" + i + this.index,
            smiles: old[i].smiles,
          });
          if (index === 3 && newV.length === old.length) {
            setTimeout(() => {
              this.showAllSvg = true;
            }, 500);
          }
          setTimeout(() => {
            let res = document.querySelectorAll(".indigo-svg-wrapper");
            for (let i = 0; i < res.length; i++) {
              let width = res[i].children[0].getAttribute("width");
              if (width.split("pt")[0] > 900) {
                res[i].style.width = "170px";
              } else if (width.split("pt")[0] > 800) {
                res[i].style.width = "150px";
              } else if (width.split("pt")[0] > 600) {
                res[i].style.width = "130px";
              } else if (width.split("pt")[0] > 400) {
                res[i].style.width = "110px";
              } else if (width.split("pt")[0] > 240) {
                res[i].style.width = "90px";
              } else if (width.split("pt")[0] > 120) {
                res[i].style.width = "70px";
              } else if (width.split("pt")[0] > 85) {
                res[i].style.width = "50px";
              } else if (width.split("pt")[0] > 50) {
                res[i].style.width = "35px";
              } else {
                res[i].style.width = "20px";
              }
            }
          });
        });
      }
    },
    createRandomId() {
      return (
        (Math.random() * 10000000).toString(16).substr(0, 4) +
        "-" +
        new Date().getTime() +
        "-" +
        Math.random().toString().substr(2, 5)
      );
    },
    getReactionDetail(type, smilesId, svgStr, smiles) {
      let newStr = this.str;
      newStr.smiles = smiles;
      let str = JSON.stringify(newStr);
      let index = "Id" + this.createRandomId();
      window.sessionStorage.setItem(`${index}`, str);
      window.open(
        `#/reaction_detail?smilesId=${smilesId}&type=${type}&str=${index}`
      );
    },
    uniqueArr(arr) {
      let result = {};
      let finalResult = [];
      for (let i = 0; i < arr.length; i++) {
        result[arr[i].smilesId] = arr[i];
      }
      for (let item in result) {
        finalResult.push(result[item]);
      }
      return finalResult;
    },
  },
  watch: {},
};
</script>

<style lang="scss">
.smiles-container {
  display: flex;
  flex-direction: column;
  border-radius: 2px;
  -webkit-box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);
  box-shadow: 0px 0 2px 0px rgba(0, 0, 0, 0.5);
  min-width: 1200px;
  max-width: 1200px;
  justify-content: flex-end;
  align-items: center;
}
.indigo-svg-wrapper {
  cursor: pointer;
}
.indigo-svg-wrapper > svg {
  height: 220px;
  width: 100%;
  max-width: 170px;
}

div.catalyst-svg > svg {
  height: 110px;
}

.smiles-canvas-wrapper {
  position: relative;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .fan-con {
    margin-right: 20px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-grow: 1;
  }

  .cui-con {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: relative;
    flex-grow: 1;
  }

  .sheng-con {
    margin-left: 40px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-grow: 1;
  }
}

.mole-canvas-wrapper {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 20px;

  .mole-cui {
    padding: 10px 20px;
    margin-bottom: 30px;
    position: relative;
    display: flex;
    min-width: 100px;
  }

  .mole-sheng {
    padding: 0 10px;
  }
}

.description {
  text-align: left;
  padding: 10px;
  width: 100%;
  display: flex;
  align-items: flex-start;

  .cui-itmes-wrapper {
    display: flex;
    justify-content: left;
    align-items: center;
    width: 50%;
  }
}

.arrow::after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 100%;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 18px solid transparent;
  border-left: 18px solid black;
}
</style>
